// Func = limiting Scope for this file
const body = document.body, html = document.documentElement;
const dheight = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );


(function(){
	$('.sym-slides').slick();

	//carbonara and rooftop menu
	if(document.getElementsByClassName('target-menu').length > 0){
		var targets = document.getElementsByClassName('target-menu__item')
		var alldatas = []
		for(let j = 0; j < targets.length; j++){
			targets[j].addEventListener('click', function(){
				for(let m = 0; m < targets.length; m++){
					targets[m].classList.remove('active')
				}
				animateto(this.getAttribute('data'))
				this.classList.add('active')
			})
			alldatas.push(targets[j].getAttribute('data'))
		}
	}

	//loader
	if(document.getElementById('loader')){
		let audioPlayed = false;
		let dontPlayAudio = false;
		let loader_audio = document.getElementById("loader_audio");
		loader_audio.addEventListener("canplay", playAudio);
		document.addEventListener('click', playAudio);
		playAudio();
		function playAudio() {
			// console.log('call PlayAudio');
			if( !audioPlayed && !dontPlayAudio && loader_audio.readyState===4 ) {
				loader_audio.play().then((something)=> { 
					audioPlayed = true;
					// document.removeEventListener('mousemove', playAudio);
					document.removeEventListener('click', playAudio);
				}).catch( (reason) => {
					// console.log('Play Audio - Handle rejected promise ('+reason+') here.');
				});
			}
		}
		setTimeout(() => {
			document.getElementById('loader').classList.add('ready');
		}, 1200);
		setTimeout(() => {
			dontPlayAudio = true;
			document.getElementById('loader').classList.add('removeLoader');
			document.removeEventListener('click', playAudio);
			loader_audio.pause();
		}, 7000);
	}
	
	

	scrollDown();
	resizeWindow();

	//enter animation
	setTimeout(function(){
		document.getElementById('start-content').classList.add('ready')
	}, 400);

	window.addEventListener('scroll', function(){
        scrollDown();
	});

	window.onresize = function(){
        resizeWindow();
	}

	//Show header menu and booking widget 
	document.getElementById('burgerMenu').addEventListener('click', function(){
		document.getElementsByClassName('menu-block')[0].classList.add('open')
		document.getElementById('header').classList.add('pioneer')
	});
	if (document.getElementById('bookingCta')) {
		document.getElementById('bookingCta').addEventListener('click', function(){
			document.getElementsByClassName('booking-form-block')[0].classList.add('open')
			document.getElementById('header').classList.add('pioneer')
		});
	}
	//Hide header menu and booking widget 
	let closes = document.getElementsByClassName('close')
	for(let i=0; i < closes.length; i++){
		closes[i].addEventListener('click', function(){
			this.parentElement.parentElement.parentElement.classList.remove('open')
			document.getElementById('header').classList.remove('pioneer')
		})
	}

	//custom h2 

	let allcustom = document.getElementsByClassName('custom');
	console.log(allcustom);
	if(allcustom.length > 0){
		for(let i=0; i < allcustom.length; i++){
			let allitems = allcustom[i].getElementsByClassName('item');
			for(let j=0; j < allitems.length; j++){
				if(allitems[j].getElementsByTagName('h2').length > 0){
					let title = allitems[j].getElementsByTagName('h2')[0];
					let titlebottom = document.createElement('div');
					titlebottom.innerHTML = '<span>'+title.innerHTML+'</span>';
					titlebottom.classList.add('titlebottom');
					title.parentNode.insertBefore(titlebottom, allitems[j].getElementsByTagName('p')[0]);
				}
				
			}
		}
	}


	//default list bg layout
	if(document.getElementsByClassName('list-bg')){
		const alllist = document.getElementsByClassName('list-bg')
		for(let i=0; i < alllist.length; i++){
			let item = alllist[i].getElementsByClassName('item')[0]
			item.insertBefore(item.getElementsByTagName('h2')[0],item.getElementsByClassName('copy-text')[0])
			//h2 cut
			let h2span = item.getElementsByTagName('h2')[0].getElementsByTagName('span')[0].innerHTML.split('')
			let h2bottom = document.createElement('div')
			h2bottom.classList.add('h2-bottom')
			let h2html = ''
			if(h2span.length >= 5){
				for(let j=h2span.length - 1; j >= h2span.length - 5; j--){
					h2html = h2span[j] + h2html
				}
			} else {
				for(let j=h2span.length - 1; j >0; j--){
					h2html = h2span[j] + h2html
				}
			}
			h2bottom.innerHTML = '<span>' + h2html + '</span>'
			item.appendChild(h2bottom)
			let h2left = item.getElementsByTagName('h2')[0].getElementsByTagName('span')[0].offsetWidth - h2bottom.offsetWidth
			h2bottom.style.left = h2left + 'px'
		}
	}

	//default list with inset and bg layout
	if(document.getElementsByClassName('list-inset-bg')){
		const allinset = document.getElementsByClassName('list-inset-bg')
		for(let i=0; i<allinset.length; i++){
			let h2 = allinset[i].getElementsByTagName('h2')[0]
			allinset[i].getElementsByClassName('container')[0].insertBefore(h2, allinset[i].getElementsByClassName('flex-box')[0])
			let newbottom = document.createElement('div')
			let h2html = h2.getElementsByTagName('span')[0].innerHTML
			newbottom.classList.add('titlebottom')
			newbottom.innerHTML = '<span>' + h2html + '</span>'
			allinset[i].getElementsByClassName('container')[0].appendChild(newbottom)
		}
	}

	// //accommodations shortcode
	 if(document.getElementsByClassName('accommodations-block').length > 0){
		//first rooms to show deluxe
		searchRooms('deluxe');
		let allfilters = document.getElementsByClassName('filter');
		for(let g = 0; g < allfilters.length; g++){
			if(allfilters[g].getAttribute('data-target') == 'deluxe'){
				allfilters[g].classList.add('active');
			}
			allfilters[g].addEventListener('click', function(){
				let target = this.getAttribute('data-target');
				searchRooms(target);
				for(let g = 0; g < allfilters.length; g++){
					allfilters[g].classList.remove('active');
				}
				this.classList.add('active');
			});
		}
	// 	//active at first and find its content
	// 	document.getElementsByClassName('toclick')[0].classList.add('active');
	// 	const firstA = document.getElementsByClassName('toclick')[0].getAttribute('data-target');
	// 	const allinfo = document.getElementsByClassName('single-room');
	// 	for(let i=0; i<allinfo.length; i++){
	// 		if(allinfo[i].getAttribute('data-target') == firstA){
	// 			allinfo[i].classList.add('active')
	// 		}
	// 	}

	// 	//accommodations interaction
	// 	const toclick = document.getElementsByClassName('toclick');
	// 	for(let i = 0; i< toclick.length; i++){
	// 		toclick[i].addEventListener('click', function(){
	// 			//remove the active state to all filter
	// 			for(let j = 0; j<toclick.length; j++){
	// 				toclick[j].classList.remove('active');
	// 			}
	// 			//add again the active state to the one clicked
	// 			this.classList.add('active');
	// 			for(let i=0; i<allinfo.length; i++){
	// 				allinfo[i].classList.remove('active')
	// 			}
	// 			for(let i=0; i<allinfo.length; i++){
	// 				if(allinfo[i].getAttribute('data-target') == this.getAttribute('data-target')){
	// 					allinfo[i].classList.add('active')
	// 				}
	// 			}
	// 		});
	// 	}

	// 	//move acessible to the bottom
	// 	let allfiltertags = document.getElementsByClassName('filter-block__filter')
	// 	for(let i = 1; i < allfiltertags.length; i++){
	// 		allfiltertags[i].parentNode.insertBefore(allfiltertags[i], allfiltertags[0]);
	// 	}
	 }


	//rooftop menus tougle
	if(document.getElementById('rooftop')){

		// const allfilter = document.getElementsByClassName('menus__filters__filter')
		// doSearch(allfilter[0].getAttribute('data-filter'))

		// for(let j =0; j < allfilter.length; j++ ){
		// 	allfilter[j].addEventListener('click',function(){
		// 		if(allfilter[j].classList.contains('toclick')){
		// 			for(let i =0; i < allfilter.length; i++ ){
		// 				allfilter[i].classList.add('toclick')
		// 				allfilter[i].classList.remove('active')
		// 			}
		// 			this.classList.remove('toclick')
		// 			this.classList.add('active')
		// 			let ctarget = this.getAttribute('data-filter')
		// 			doSearch(ctarget)
		// 		}
		// 	});
		// }

		//vip h2
		if(document.getElementsByClassName('rooftop-vip')[0].getElementsByTagName('h2').length > 0){
			//move the h2 from the custom field and add it before the image
			let h2title = document.getElementsByClassName('rooftop-vip')[0].getElementsByTagName('h2')[0];
			let targetp = document.getElementsByClassName('rooftop-vip')[0].getElementsByClassName('container')[0]
			let newsibiling = document.getElementsByClassName('rooftop-vip')[0].getElementsByClassName('flex-box')[0]

			targetp.insertBefore(h2title, newsibiling);
			//add the moved text to title
			let cuttitle = document.createElement('div')
			cuttitle.classList.add('title-cut')
			cuttitle.innerHTML = '<span>'+ h2title.getElementsByTagName('span')[0].innerHTML +'</span>'
			targetp.appendChild(cuttitle);
		}
	}

	// carbonara
	if(document.getElementById('carbonara')){
		//gallery
		let imagescontainer = document.getElementsByClassName('gallery-block__images')[0]
		const galimages = imagescontainer.getElementsByClassName('image')
		let imagesblock = document.createElement('div')
		imagesblock.classList.add('images-block')
		imagesblock.classList.add('clearfix')
		imagescontainer.insertBefore(imagesblock, galimages[0]);
		for(let i=0; i< galimages.length; i++){
			if(!galimages[i].getElementsByTagName('a')[0].classList.contains('long')){
				imagesblock.appendChild(galimages[i])
			}
		}

		//menus trigger
		let allmenus = document.getElementsByClassName('menu')
		for(let j = 0; j < allmenus.length; j++){
			allmenus[j].getElementsByClassName('product')[0].classList.add('active')
			allmenus[j].getElementsByClassName('product-items')[0].classList.add('active')
		}
		let allproducts = document.getElementsByClassName('product')
		for(let a = 0; a < allproducts.length; a++){
			allproducts[a].addEventListener('click', function(){
				let current = this.getAttribute('data-target')

				//remove the active state only to the ones of the same menu
				for(let b = 0; b < this.parentElement.parentElement.getElementsByClassName('product-items').length; b++){
					this.parentElement.parentElement.getElementsByClassName('product-items')[b].classList.remove('active')
				}
				for(let b = 0; b < this.parentElement.getElementsByClassName('product').length; b++){
					this.parentElement.getElementsByClassName('product')[b].classList.remove('active')
				}
				this.classList.add('active')
				// set active state
				for(let b = 0; b < document.getElementsByClassName('product-items').length; b++){
					if(document.getElementsByClassName('product-items')[b].getAttribute('data-target') == current ){
						document.getElementsByClassName('product-items')[b].classList.add('active')
					}
				}
			})
		}
	}

	

	//booking select pre selected
	//document.getElementById('rooms').getElementsByTagName('option')[1].selected = true;
	//document.getElementById('adults').getElementsByTagName('option')[1].selected = true;


	//get if there is a # on url
	if(window.location.hash){
		let path = window.location.href.split('#')[1];
		setTimeout(function(){
			animateto(path)
		}, 1300);
		
	}

	//expand from blogs
	if(document.getElementsByClassName('expandfull').length > 0){
		let allexpand = document.getElementsByClassName('expandfull')
		for( let j = 0; j < allexpand.length; j++){
			allexpand[j].addEventListener('click', function(){
				if(!this.previousElementSibling.classList.contains('show')){
					this.innerHTML = 'Read Less'
					this.previousElementSibling.classList.add('show')
				} else {
					this.innerHTML = 'Read More'
					this.previousElementSibling.classList.remove('show')
				}
				
			})
		}
	}

	//if it is sitemap
	if(document.getElementsByClassName('sitemap').length > 0){
		
		document.getElementsByTagName('h1')[0].innerHTML = '<span>' + document.getElementsByTagName('h1')[0].innerHTML + '</span>'
		document.getElementsByClassName('part-title')[0].innerHTML = '<span>' + document.getElementsByTagName('h1')[0].innerHTML + '</span>'
	}


	//if map page
	if(document.getElementsByClassName('map').length > 0){
		let backbtn = document.createElement('a')
		backbtn.innerHTML = '« Back to previous page'
		backbtn.classList.add('map-btn')
		backbtn.classList.add('back')
		backbtn.setAttribute('href','javascript:history.back()')
		document.getElementById('content').appendChild(backbtn)
		
		let adabtn = document.createElement('a')
		adabtn.innerHTML = 'Visit Accessible Map Page'
		adabtn.classList.add('map-btn')
		adabtn.classList.add('ada')
		adabtn.setAttribute('href','/ada-attractions')
		document.getElementById('content').appendChild(adabtn)
	}


    

	
	$(document).ready(function () {
		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}
		//Check in and check out datepicker for booking engine		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: "mm-dd-yy",
            numberOfMonths: 1,
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 1);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			dateFormat: "mm-dd-yy",
            changeMonth: true,
			numberOfMonths: 1,
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});
		//instagramAjaxFeed('hotelhendricksny',8,'#home-instagram__gallery',320,'.home-instagram');

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

		//remove attributes ada
		$('#third-nav').removeAttr('aria-label');
	});

}());

function scrollDown(){
	let topp = window.pageYOffset;
	if(document.getElementById('home')){
		if(topp > 60){
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementsByClassName('js-booking-block')[0].classList.remove('at-home');
				document.getElementById('bookingCta').classList.remove('at-home');
			}
		} else {
			if(document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.remove('down');
				document.getElementsByClassName('js-booking-block')[0].classList.add('at-home');
				document.getElementById('bookingCta').classList.add('at-home');
			}
		}
	} else {
		if(!document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.add('down');
		}	
	}
	//lazy conflict
	const top = window.scrollY;
	let animatedEl = document.getElementsByClassName('animate-fade-2');
	const h = window.innerHeight;
	var i;
	for (i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		//animatedEl[i].innerHTML = topPos;
		if(topPos <= h*0.8){
			animatedEl[i].classList.add('fade-in');
		}
	}

	//carbonara and rooftop menu
	if(document.getElementsByClassName('target-menu').length > 0){
		let difference = dheight - 2000
		if(top >= difference){
			if(!document.getElementsByClassName('target-menu')[0].classList.contains('noshow')){
				document.getElementsByClassName('target-menu')[0].classList.add('noshow')
			}
		} else {
			if(document.getElementsByClassName('target-menu')[0].classList.contains('noshow')){
				document.getElementsByClassName('target-menu')[0].classList.remove('noshow')
			}
		}
	}
}
function resizeWindow(){
	//window.innerWidth
	if(document.getElementById('home')){
		document.getElementsByClassName('top-content')[0].style.height = window.innerHeight + 'px';
	}
}

function doSearch(target){
	$("#menuContainer").html('');
	$.post(`${site_url}ajax/functions.php`, {
			operation: 'getMenuProducts',
			menu:target
		}, 
		function(data) {
			$("#menuContainer").append(data);
		}, 'html'
	);
}
//rooms
function searchRooms(tag){
	$("#roomsList").html('');
	$(".accommodations-block").addClass('preshow');
	$(".accommodations-block").removeClass('postshow');
	$.post(`${site_url}ajax/functions.php`, {
			operation: 'getRooms',
			tag:tag
		}, 
		function(data) {
			$("#roomsList").append(data);
			
			$(".accommodations-block").addClass('postshow');
			setTimeout(function(){
				$('.regular-slick').slick({
					fade:true,
					accessibility:true
				});
				$(".accommodations-block").removeClass('preshow');
			},300);
		}, 'html'
	);
}

function animateto(target){
	//var gotoTarget = document.getElementById(target).offsetTop - 200
	var gotoTarget = offset(document.getElementById(target)).top - 250


	var diff = window.pageYOffset - gotoTarget
	var time = 0
	var position = window.pageYOffset
	var origen = window.pageYOffset
	var animation = setInterval(frame);
	function frame(){
		time += 1 / 100;
	
		if(origen > gotoTarget){
			position = window.pageYOffset - 10;
			if (position <= gotoTarget ) {
					console.log('stop');
					clearInterval(animation);
			} else {
					window.scrollTo(0, position);
			}
		} else {
			position = window.pageYOffset + 10;
			if (position >= gotoTarget ) {
					console.log('stop');
					clearInterval(animation);
			} else {
					window.scrollTo(0, position);
			}
		}
	}
 }
 function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

